/* eslint-disable */
/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { TooltipIcon as Tooltip } from 'components/Tooltip';
import useStyles from './style';

interface AnonymousLoginButtonProps {
  onClick: () => void;
}

export default function AnonymousLoginButton(props: AnonymousLoginButtonProps) {
  const { onClick } = props;
  const classes = useStyles();

  const anonymousBannerTooltipText = (
    <div className={classes.anonymousBannerTooltipTextContainer}>
      <Typography className={classes.anonymousBannerTooltipText}>
        <FormattedMessage
          id="console.navbar.anonymous.banner.tooltip.title"
          defaultMessage="If you are accessing WSO2 Integration Platform anonymously on a shared computer, 
          be sure to take necessary precautions to mitigate leakage of code, credentials, and confidential information."
        />
      </Typography>
      <div className={classes.anonymousBannerTooltipHorizontalLine} />
      <Typography className={classes.anonymousBannerTooltipLinkTextContainer}>
        <a
          href="https://wso2.com/devant/docs/references/anonymous-access/"
          target="_blank"
          className={classes.anonymousBannerTooltipLinkText}
          rel="noreferrer"
        >
          <FormattedMessage
            id="console.navbar.anonymous.banner.tooltip.actionText"
            defaultMessage="Read more"
          />
        </a>
      </Typography>
    </div>
  );

  return (
    <>
      <Divider variant="middle" className={classes.anonymousDivider} />
      <Tooltip
        title={anonymousBannerTooltipText}
        arrow
        placement="right-start"
        interactive
      >
        <Button
          id="anonymous-user-login"
          onClick={onClick}
          className={classes.anonymousBtn}
          variant="contained"
          role="button"
        >
          <Typography variant="h5">
            <FormattedMessage
              id="authentication.login.button.withAnonymousUser"
              defaultMessage="Try WSO2 Integration Platform Anonymously"
            />
          </Typography>
        </Button>
      </Tooltip>
    </>
  );
}
